import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Ticket, SwimmingPool, WifiHigh, Park, Star, Users, Gift } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const tickets = [
  {
    id: "single_entry", title: "Entrada Única", price: 20, color: "from-[#0891B2] to-[#0E7490]",
    benefits: ["Acesso a piscina", "Área de lazer", "WiFi gratuito"],
  },
  {
    id: "monthly_passport", title: "Passaporte Mensal", price: 180, color: "from-[#FF5A26] to-[#E04818]", badge: "Popular",
    benefits: ["Acesso ilimitado a piscina 30 dias", "Prioridade em reservas", "10% desconto em Serviços"],
  },
  {
    id: "annual_passport", title: "Passaporte Anual VIP", price: 1920, color: "from-[#042F2E] to-[#115E59]", badge: "VIP",
    benefits: ["Acesso ilimitado a piscina 1 ano", "3 convidados grátis/mês", "Participa de sorteios", "Entrada exclusiva"],
  },
];

const Tickets = () => {
  const navigate = useNavigate();

  const handleBuy = (item) => {
    navigate("/pix-payment", {
      state: { itemId: item.id, itemType: "package", itemInfo: { title: item.title, description: "Ingresso", price: item.price } }
    });
  };

  return (
    <div>
      <h2 className="text-2xl sm:text-3xl font-bold text-[#042F2E] mb-2">Ingressos & Passaportes</h2>
      <p className="text-[#115E59] mb-8">Escolha o melhor plano para você</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {tickets.map((item, i) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="bg-white rounded-2xl border border-[#E4DFD3] overflow-hidden shadow-sm hover:shadow-lg transition-shadow"
            data-testid={`ticket-card-${item.id}`}
          >
            <div className={`bg-gradient-to-br ${item.color} p-6 text-white relative`}>
              {item.badge && (
                <span className="absolute top-4 right-4 bg-white/20 text-white text-xs font-bold px-3 py-1 rounded-full">{item.badge}</span>
              )}
              <Ticket size={36} weight="duotone" className="mb-3 opacity-80" />
              <h3 className="text-xl font-bold">{item.title}</h3>
              <div className="mt-2">
                <span className="text-3xl font-black">R$ {item.price.toFixed(2).replace(".", ",")}</span>
              </div>
            </div>
            <div className="p-6">
              <ul className="space-y-2.5 mb-6">
                {item.benefits.map((b, j) => (
                  <li key={j} className="flex items-start gap-2.5 text-sm text-[#042F2E]">
                    <Star size={16} weight="fill" className="text-[#FF5A26] shrink-0 mt-0.5" />
                    {b}
                  </li>
                ))}
              </ul>
              <Button
                onClick={() => handleBuy(item)}
                className={`w-full bg-gradient-to-r ${item.color} text-white font-bold rounded-full py-5`}
                data-testid={`buy-ticket-${item.id}`}
              >
                Comprar
              </Button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Tickets;
